const routes = {
    home: '/',
    bodymap: '/bodymap',
    supplements: '/supplements',
    supplement: '/supplements/:name',
    drug: '/drug/',
};

export default routes;
